import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import Typography from '@material-ui/core/Typography';
import { i18n } from '../../translate/i18n';
import { useMetricsContext } from '../../context/Metrics/MetricsContext';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      display: false,
    },
    title: {
      display: true,
      text: i18n.t('dashboard.charts.date.label'),
      position: 'left',
    },
    datalabels: {
      display: true,
      anchor: 'start',
      offset: -30,
      align: 'start',
      color: '#fff',
      textStrokeColor: '#000',
      textStrokeWidth: 2,
      font: {
        size: 20,
        weight: 'bold',
      },
    },
  },
};

export const ChartsDate = () => {
  // Usar o contexto unificado de métricas
  const { metrics, loading } = useMetricsContext();

  // Extrair dados de distribuição horária do endpoint unificado
  const hourlyDistribution = metrics?.messageMetrics?.hourlyDistribution || [];

  const dataCharts = {
    labels:
      hourlyDistribution.length > 0
        ? hourlyDistribution.map(
          item => `Das ${item.hour}:00 às ${item.hour}:59`
        )
        : [],
    datasets: [
      {
        label: i18n.t('dashboard.charts.message'),
        data:
          hourlyDistribution.length > 0
            ? hourlyDistribution.map(item => item.sent + item.received)
            : [],
        backgroundColor: '#24B4A5',
      },
    ],
  };

  return (
    <>
      <Typography component='h2' variant='h6' color='primary' gutterBottom>
        {i18n.t('dashboard.charts.date.title')} (
        {hourlyDistribution.length > 0
          ? hourlyDistribution.reduce(
            (total, item) => total + item.sent + item.received,
            0
          )
          : 0}
        )
      </Typography>

      <Bar
        options={options}
        data={dataCharts}
        style={{ maxWidth: '100%', maxHeight: '280px' }}
      />
    </>
  );
};
